import type { CSSProperties, ReactNode } from "react";
import { dashboardCardStyle } from "./dashboardStyles";

interface DashboardCardShellProps {
  children: ReactNode;
  accentColor?: string;
  style?: CSSProperties;
  testId?: string;
}

export function DashboardCardShell({
  children,
  accentColor,
  style,
  testId,
}: DashboardCardShellProps) {
  return (
    <section
      data-testid={testId}
      style={{
        ...dashboardCardStyle,
        background:
          "color-mix(in srgb, var(--login-surface) 96%, var(--login-bg))",
        boxShadow:
          "0 1px 0 color-mix(in srgb, var(--login-text) 4%, transparent)",
        containerType: "inline-size",
        ...(accentColor ? { borderLeft: `3px solid ${accentColor}` } : {}),
        ...style,
      }}
    >
      {children}
    </section>
  );
}
